var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('Grid',[_c('GridItem',{attrs:{"gridSpan":4}},[_c('ParagraphBody',{attrs:{"bodySize":"large"}},[_vm._v(" Have questions? Search our knowledge base. ")])],1),_c('GridItem',{attrs:{"gridSpan":5}},[_c('KnowledgeBaseSearch',{attrs:{"section":_vm.section}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }